import apiClient from './apiClient';

/**
 * Jewish Holidays API Service
 * Provides access to the jewish_holidays database table
 */
const jewishHolidaysService = {
  /**
   * Get holidays for a date range
   * @param {string} startDate - YYYY-MM-DD format
   * @param {string} endDate - YYYY-MM-DD format
   * @param {string} category - Optional filter: major, minor, fast, rosh_chodesh, shabbat, modern
   * @returns {Promise<Array>} Array of holiday objects
   */
  getHolidays: async (startDate, endDate, category = null) => {
    console.log('🔌 jewishHolidaysService.getHolidays called');
    console.log('  - Parameters:', { startDate, endDate, category });
    
    const params = { startDate, endDate };
    if (category && category !== 'all') {
      params.category = category;
    }
    
    console.log('  - Final params:', params);
    console.log('  - Request URL: /jewish-holidays/holidays');
    
    try {
      const response = await apiClient.get('/jewish-holidays/holidays', { params });
      console.log('  - Response status:', response.status);
      console.log('  - Response data:', response.data);
      console.log('  - Data type:', typeof response.data);
      console.log('  - Is array:', Array.isArray(response.data));
      console.log('  - Count:', response.data?.length || 0);
      return response.data;
    } catch (error) {
      console.error('❌ API Error in jewishHolidaysService.getHolidays:', error);
      console.error('  - Error message:', error.message);
      console.error('  - Error response:', error.response);
      throw error;
    }
  },
  
  /**
   * Get holidays for a specific month
   * @param {number} year - 4-digit year
   * @param {number} month - 1-12
   * @returns {Promise<Array>} Array of holiday objects
   */
  getMonthHolidays: async (year, month) => {
    const response = await apiClient.get(`/jewish-holidays/holidays/month/${year}/${month}`);
    return response.data;
  },
  
  /**
   * Get holidays for a specific date
   * @param {string|Date} date - Date object or YYYY-MM-DD string
   * @returns {Promise<Array>} Array of holiday objects for that date
   */
  getHolidaysForDate: async (date) => {
    const dateStr = date instanceof Date 
      ? date.toISOString().split('T')[0] 
      : date;
    
    const response = await apiClient.get(`/jewish-holidays/holidays/date/${dateStr}`);
    return response.data;
  },
  
  /**
   * Get all major holidays (Yom Tov - work prohibited)
   * @returns {Promise<Array>} Array of major holiday objects
   */
  getMajorHolidays: async () => {
    const response = await apiClient.get('/jewish-holidays/holidays/major');
    return response.data;
  },
  
  /**
   * Get upcoming holidays (next 30 days)
   * @returns {Promise<Array>} Array of upcoming holiday objects
   */
  getUpcomingHolidays: async () => {
    const response = await apiClient.get('/jewish-holidays/holidays/upcoming');
    return response.data;
  },
  
  /**
   * Get statistics about holidays in the database
   * @returns {Promise<Object>} Stats object with total, byCategory, and dateRange
   */
  getStats: async () => {
    const response = await apiClient.get('/jewish-holidays/holidays/stats');
    return response.data;
  }
};

export default jewishHolidaysService;
